import { deviceRows } from "@/pages/CompareDevices/components/CompareSection/mockData";
import {
  Box,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  Typography,
  useTheme,
} from "@mui/material";

import {
  getCharacteristicCellStyles,
  getCharacteristicNameStyles,
  getCharacteristicStyle,
  getCharacteristicValueStyle,
  getComponentByName,
  getDeviceCellStyles,
  getProductFeaturesOptions,
  getValueForAttribute,
  rowStyles,
} from "./utils";
import useResponsive from "@/hooks/useResponsive";

export const BORDER_STYLE = "1px solid #EDEDED";

interface IProps {
  allProducts: ICompareProduct[];
  productFeatures: IProductFeatureConfig[];
}

const TableCompare: React.FC<IProps> = ({ allProducts, productFeatures }) => {
  const theme = useTheme();
  const isMobile = useResponsive("down", "lg");
  const isLargeDesktop = useResponsive("up", "xl");

  const productFeaturesOptions = getProductFeaturesOptions(productFeatures);

  return (
    <TableContainer
      sx={{
        width: "100%",
        overflowX: "auto",
        boxShadow: "0 24px 48px -12px rgba(93,97,104,.1)",
      }}
    >
      <Table
        sx={{
          tableLayout: { md: "fixed" },
          borderCollapse: "separate",
        }}
      >
        <TableBody>
          {deviceRows.map((name, index) => (
            <TableRow key={index} sx={{ border: "none" }}>
              {/* Empty cell */}
              {!isMobile && (
                <TableCell
                  sx={{
                    padding: "0px",
                    border: "none",
                    width: isLargeDesktop ? "344px" : "300px",
                  }}
                />
              )}

              {allProducts.map((device, deviceIndex, cells) => (
                <TableCell
                  key={deviceIndex}
                  sx={getDeviceCellStyles(
                    theme,
                    index,
                    deviceIndex,
                    cells.length
                  )}
                >
                  {getComponentByName(theme, device, name)}
                </TableCell>
              ))}
            </TableRow>
          ))}

          {productFeaturesOptions.map(
            ({ featureMasterID, featureTitle, withStar }, index, rows) => (
              <TableRow key={featureMasterID} sx={rowStyles}>
                {!isMobile && (
                  // Attribute name
                  <TableCell
                    sx={{ border: "none", height: "78px", padding: "0px" }}
                  >
                    <Box sx={getCharacteristicStyle(index, rows.length)}>
                      <Box sx={getCharacteristicNameStyles(theme)} />
                      <Typography
                        sx={{ width: "90%" }}
                        fontWeight={700}
                        fontSize={"1rem"}
                        color="text.primary"
                      >
                        {featureTitle}
                        {withStar ? (
                          <Typography component="span" color="text.accent">
                            *
                          </Typography>
                        ) : null}
                      </Typography>
                    </Box>
                  </TableCell>
                )}

                {allProducts.map(({ productFeatures }, deviceIndex, cells) => (
                  <TableCell
                    sx={getCharacteristicCellStyles(
                      index,
                      deviceIndex,
                      rows.length,
                      cells.length,
                      isMobile
                    )}
                    key={deviceIndex}
                  >
                    <Box
                      sx={getCharacteristicValueStyle(
                        theme,
                        index,
                        deviceIndex,
                        rows.length,
                        cells.length,
                        isMobile
                      )}
                    >
                      {isMobile && (
                        <Typography
                          fontWeight={700}
                          fontSize={"1rem"}
                          color="text.primary"
                          sx={{ width: "50%" }}
                        >
                          {featureTitle}
                          {withStar ? (
                            <Typography component="span" color="text.accent">
                              *
                            </Typography>
                          ) : null}
                        </Typography>
                      )}
                      {getValueForAttribute(
                        productFeatures,
                        featureMasterID,
                        isMobile
                      )}
                    </Box>
                  </TableCell>
                ))}
              </TableRow>
            )
          )}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default TableCompare;
